
<!-- Vertical stepper -->
<ng-container *ngIf="patched">

<fuse-alert [type]="'error'" *ngIf="buletinInfForm.invalid" class="my-3">
    <span fuseAlertTitle>Lipsesc date,sau datele introduse contin erori.</span>
    Corectati / completati datele introduse apoi butonul de finalizare se va activa.
</fuse-alert>

<fuse-alert [type]="'error'" *ngIf="!signatureAvailable && stepper.selectedIndex == 1" class="my-3">
    <span fuseAlertTitle>Lipsa semnatura.</span>
    Introduceti semnatura, apoi butonul de finalizare se va activa.
</fuse-alert>

<fuse-alert [type]="'success'" *ngIf="!buletinInfForm.invalid && signatureAvailable" class="my-3">
    <span fuseAlertTitle>Totul arata bine!</span>
    Formularul este valid, buna treaba!
</fuse-alert>

    <form
    class="p-0 bg-card shadow rounded overflow-hidden"
    [formGroup]="buletinInfForm">
    <mat-vertical-stepper #stepper
        [linear]="true">
        <mat-step
            [formGroupName]="'step1'"
            [stepControl]="buletinInfForm.get('step1')"
            #verticalStepperStep2>
            <ng-template matStepLabel>Chestionar</ng-template>
            <ng-container *ngFor="let entry of gdprQuestions;">
                <div class="flex flex-col w-full">
                    <div class="flex flex-col gap-1">
                        <p class="text-lg" *ngIf="entry.title"><b>{{entry.title.replace("{nume_cabinet}", clinicName)}}</b></p>
                        <p class="text-lg">{{entry.q.replace("{nume_cabinet}", clinicName)}}</p>
                    </div>

                    <ng-container *ngFor="let answer of entry.answsL1;">

                        <div class="flex flex-row gap-1 items-center mt-1">
                            <input type="checkbox" class="cursor-pointer" [checked]="getSelectionValue(answer)" (change)="syncFieldCheck(answer, $event, entry)">
                            <p class="ml-2">{{getAnswerText(answer).replace("{nume_cabinet}", clinicName)}}</p>
                        </div>

                        <div *ngIf="answer.txt.includes('{extra}') && getSelectionValue(answer)" class="w-full mt-4">
                            <mat-form-field class="flex-auto w-full">
                                    <input
                                        matInput
                                        [placeholder]="'Introduceti informatiile'"
                                        [value]="this.fieldsData[answer.id+'extra']"
                                        (focusout)="syncExtraField(answer.id+'extra', $event)">
                                <mat-icon
                                    class="icon-size-5"
                                    matPrefix
                                    [svgIcon]="'heroicons_solid:bars-3-bottom-left'"></mat-icon>
                            </mat-form-field>

                        </div>

                        <div *ngIf="answer.hasL2 && isL1Ticked(answer.id)" class="w-full ml-8">
                            <ng-container *ngFor="let answerL2 of entry.answsL2;">

                                <div class="flex flex-row gap-1 items-center mt-1 cursor-pointer">
                                    <input type="checkbox" class="cursor-pointer" [checked]="getSelectionValue(answerL2)" (change)="syncFieldCheck(answerL2, $event, entry)">
                                    <p class="ml-2">{{getAnswerText(answerL2).replace("{nume_cabinet}", clinicName)}}</p>
                                </div>

                                <div *ngIf="answerL2.txt.includes('{extra}') && getSelectionValue(answerL2)" class="w-full mt-4">
                                    <mat-form-field class="flex-auto w-full">
                                        <input
                                            matInput
                                            [placeholder]="'Introduceti informatiile'"
                                            [value]="this.fieldsData[answerL2.id+'extra']"
                                            (focusout)="syncExtraField(answerL2.id+'extra', $event)">
                                        <mat-icon
                                            class="icon-size-5"
                                            matPrefix
                                            [svgIcon]="'heroicons_solid:bars-3-bottom-left'"></mat-icon>
                                    </mat-form-field>

                                </div>
                            </ng-container>
                        </div>

                    </ng-container>
                    <mat-divider class="my-5"></mat-divider>
                </div>
            </ng-container>
            <div class="flex justify-end">
                <button
                    class="px-8 mr-2"
                    mat-flat-button
                    [color]="'accent'"
                    type="button"
                    matStepperPrevious>
                    {{ 'Back' | transloco }}
                </button>
                <button
                    class="px-8"
                    mat-flat-button
                    [color]="'primary'"
                    [disabled]="verticalStepperStep2.stepControl.invalid"
                    type="button"
                    matStepperNext>
                    {{ 'Next' | transloco }}
                </button>
            </div>
        </mat-step>

        <mat-step
            [formGroupName]="'step2'"
            [stepControl]="buletinInfForm.get('step2')"
            #verticalStepperStep2>
            <ng-template matStepLabel>Acordul si semnatura</ng-template>

            <div class="flex flex-col gap-3 w-full">

                <p class="mt-4"><b>Neacordarea consimțământului pentru utilizarea datelor cu caracter personal identificate în prezentul formular are drept consecință imposibilitatea realizării acestor activități de prelucrare în scopurile detaliat prezentate în prezentul formular, dar nu afectează în niciun fel prestarea serviciilor {{clinicName}} către dumneavoastră.</b></p>
                <p>Consimțământul acordat prin prezentul formular este valabil până la retragerea sa. </p>

                <p>Vă puteți retrage sau modifica consimțământul astfel acordat, în orice moment, prin transmiterea unei solicitări scrise cu utilizarea următoarelor coordonate:</p>
                <ul>
                    <li>Adresă poștală: {{clinicAddress}}</li>
                    <li>Adresă de e-mail: {{clinicEmail}}</li>
                </ul>

                <p>Retragerea nu afectează prelucrările efectuate anterior datei primirii acestei solicitări din partea dumneavoastră.</p>

                <ng-container>
                    <mat-divider class="w-full my-3"></mat-divider>
                    <p class="text-xl">Introduceti semnatura in chenarul de mai jos:</p>
                    <app-signature (signaturePresent)="signatureIntroduced($event)" (signatureDone)="signatureData = $event"></app-signature>
                </ng-container>

            </div>

            <div class="flex justify-end">
                <button
                    class="px-8 mr-2"
                    mat-flat-button
                    [color]="'accent'"
                    type="button"
                    matStepperPrevious>
                    {{ 'Back' | transloco }}
                </button>
                <button
                    class="px-8"
                    mat-flat-button
                    [color]="'primary'"
                    (click)="finalizeDoc(signature)"
                    [disabled]="!signatureAvailable"
                    type="button">
                    {{ 'Finalize' | transloco }}
                </button>
            </div>
        </mat-step>
    </mat-vertical-stepper>
</form>

</ng-container>
